import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn, UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment-timezone';

// This service create generic error validators.
@Injectable({
  providedIn: 'root',
})
export class ValidatorFnService {
  minDateValidator(minDate: string): ValidatorFn {
    return (control: AbstractControl) => {
      if (control.value == null) {
        return null;
      }

      const momentDate = moment(control.value);
      const minimumDate = moment(minDate);
      const isValid = momentDate.isAfter(minimumDate);
      return isValid ? null : { min: 'is wrong' };
    };
  }

  maxDateValidator(minDate: string): ValidatorFn {
    return (control: AbstractControl) => {
      if (control.value == null) {
        return null;
      }

      const momentDate = moment(control.value);
      const minimumDate = moment(minDate);
      const isValid = momentDate.isBefore(minimumDate);
      return isValid ? null : { max: 'is wrong' };
    };
  }

  // Need to create a validator with a custom error message
  requiredDateValidator(): (control: AbstractControl) => { [key: string]: any } {
    return (control: AbstractControl) => {
      if (control.value == null) {
        return { required: 'is required' };
      }

      const momentDate = moment(control.value);
      const isValid = momentDate.isValid();
      return isValid ? null : { condrequired: 'is required' };
    };
  }

  noWhiteSpaceValidator(errorMessage: string): ValidatorFn {
    if (!errorMessage) {
      errorMessage = 'is required';
    }
    return (control: AbstractControl) => {
      if (control.value == null) {
        return { condrequired: errorMessage };
      }

      // Different validations for different type of inputs
      let isValid: boolean;
      if (typeof control.value === 'string') {
        const isWhitespace = (control.value || '').trim().length === 0;
        isValid = !isWhitespace;
        return isValid ? null : { condrequired: errorMessage };
      } else if (typeof control.value === 'number') {
        isValid = control.value != null;
        return isValid ? null : { condrequired: errorMessage };
      } else if (typeof control.value === 'boolean') {
        isValid = control.value;
        return isValid != null ? null : { condrequired: errorMessage };
      } else if (Array.isArray(control.value)) {
        isValid = control.value.length > 0;
        return isValid ? null : { condrequired: errorMessage };
      }
    };
  }

  alwaysInvalidValidator(key: string, errorMessage: string): ValidatorFn {
    return () => {
      const validationError: any = {};
      validationError[key] = errorMessage;
      return validationError;
    };
  }

  atLeastOneFieldValidator(exclude: string[] = []): ValidatorFn {
    return (group: UntypedFormGroup) => {
      const formIsPopulated: boolean = Object.entries(group.controls)
        .filter(c => !exclude.includes(c[0]))
        .map(c => c[1])
        .some(control => control.value != null && control.value.toString().trim().length);

      return formIsPopulated ? null : { emptyform: 'At least one form field must be populated.' };
    };
  }

  exactNumberOfFieldsValidator(numberOfFieldsRequired: number, include: string[]): ValidatorFn {
    return (group: UntypedFormGroup) => {
      const formIsPopulated: boolean =
        Object.entries(group.controls)
          .filter(c => include.includes(c[0]))
          .map(c => c[1])
          .filter(control => control.value != null && control.value.toString().trim().length)
          .length === numberOfFieldsRequired;

      return formIsPopulated
        ? null
        : { emptyform: `Exactly ${numberOfFieldsRequired} fields must be populated.` };
    };
  }
}
